import { axios } from "../http-common";

class Withdrawal {
  remittanceList(data) {
    return axios.get("v1/member/remittance/history", { params: data });
  }
  withdrawalList(data) {
    return axios.get("v1/member/withdrawal/history", { params: data });
  }
  partnerList(data) {
    return axios.get("v1/member/withdrawal-benificiary/partner", {
      params: data,
    });
  }
  beneficiaryList(data) {
    return axios.get("v1/member/withdrawal-benificiary/list", { params: data });
  }
  submitWithdrawal(data) {
    return axios.post("v1/member/withdrawal/request", data);
  }
  submitRemittance(data) {
    return axios.post("v1/member/remittance/request", data);
  }
  addBenificiary(data) {
    return axios.post("v1/member/withdrawal-benificiary/add", data);
  }
  updatePartner(data) {
    return axios.post("v1/member/partner/update", data);
  }
  updateBeneficiary(data) {
    return axios.post("v1/member/withdrawal-benificiary/update", data);
  }
  addPartner(data) {
    return axios.post("v1/member/partner/add", data);
  }
  draftSameName(data) {
    return axios.get("v1/member/remittance/get-remittance-transit", {
      params: data,
    });
  }
  draftDifferentName(data) {
    return axios.get("v1/member/remittance/get-remittance", { params: data });
  }
  updateDraftSameName(data) {
    return axios.post("v1/member/remittance/update-remittance-transit", data);
  }
  updateDraftDifferentName(data) {
    return axios.post("v1/member/remittance/update-remittance", data);
  }
  adjustSameName(data) {
    return axios.post("v1/member/accounts/remittance-transit", data);
  }
  adjustDifferentName(data) {
    return axios.post("v1/member/remittance/request", data);
  }
}

export default new Withdrawal();
